import React, { useState } from 'react'
import passI from './pass.module.css'
import imgI from '../../../img/logo 1.png'
import { Link } from 'react-router'
const ForgetPass = () => {

    const [email, setEmail] = useState('')
        const [pass, setPass] = useState('')

  return (
    <div className={passI.pass}>
      <div className={passI.container}>
     <div className={passI.content}>
         <div className={passI.logo}>
             <img src={imgI} alt="" />
         </div>
         <div className={passI.block}>
             <div className={passI.seci}>
                 <h3>Password Verification</h3>
                 <p>Please make sure you save your password to avoid
                 forgetting your password.</p>
             </div>
             <form action="/">
                 <div className={passI.email}>
                     <label htmlFor="">New Password</label>
                     <input 
                     type="password" 
                     name="email" 
                     value={email}  id="email"
                    
                     onChange={(e) => setEmail(e.target.value)}
                     />
                 </div>
                 <div className={passI.passi}>
                     <label htmlFor="">Confirm Password</label>
                     <input 
                     type="password" 
                     name="pass" id="pass" 
                     value={pass} 
                     onChange={(e) => setPass(e.target.value)}/>
                 </div>
                 <div className={passI.secii}>
                     <p>Register your account to access your dashboard and 
                     modify your dashboard activities</p>
                     <Link to='/PublisherLogin/Previewpage'><button>Sign In</button></Link>
                 </div>
             </form>
         </div>
     </div>
    </div>
    </div>
  )
}

export default ForgetPass
